export default theme => ({

  root: {},
  content: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.border}`
  },
  buttonRight: {
    marginTop: theme.spacing(1),
    float: 'right',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
  button: {
    float: 'right',
  },
  addButton: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  map: {
    minWidth: '100%',
    minHeight: 'calc(-195px + 100vh)',
    border: '1px solid lightgrey',
    borderRadius: '3px'
  },
});


